function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { PureComponent, Children, createRef } from 'react';
import { debounce, safeSelect } from '@sie/web-common-utils';
import PropTypes from 'prop-types';
import classNames from '../utils/classNames';
import isRtl from '../utils/isRtl';
import Button from '../Button';
import Icon from '../Icon';
import MediaFrame from '../MediaFrame';
import StrandStates from './StrandStates';
var ROUGH_SMOOTH_SCROLL_ANIMATION_DURATION_MS = 300;
var ONE_FRAME_MS = 17;
/**
 * The Strand component displays a collection of UI items horizontally allowing the content to
 * scroll and keeping the height consistent
 *
 * ** Browser Support**
 *
 * This component depends on scroll-behavior and will require a polyfill for Safari
 * [Recommended PolyFill (smoothscroll-polyfill)](https://github.com/iamdustan/smoothscroll)
 * This polyfill can be loaded from  web-common browser polyfills
 *
 * **Designs**
 *
 * - [Product Strand IXD](https://atlas.np.tools.playstation.net/design/b46dafea-6646-49a9-bfb6-a9ec467c6929/1?bounds=-0.120,0.007,1.241,0.843)
 * - [Product Strand Red Lines](https://atlas.np.tools.playstation.net/design/864ab9c0-7f8e-45d4-a4b7-1dfab063ec96/1?bounds=0.379,0.673,0.385,0.262&rev=1,1,1&x=549.46,653.72,4455.94&y=809.14,3598.32,6174.10)
 * - [Editions Strand IXD](https://atlas.np.tools.playstation.net/design/f13ae03c-ae4a-433c-86db-339c1d26f71e/2?bounds=-0.206,-0.022,1.067,0.725)
 * - [Editions Strand Red Lines](https://atlas.np.tools.playstation.net/design/defebb5a-0142-4812-a676-b2fb0198f30d/5?bounds=0.344,0.412,0.515,0.368)
 *
 * **Usage**
 * Loading state
 *
 * ```jsx
 * <Strand loading loadingItem=(<div>loading...</div>)>
 * </Strand>
 * ```
 *
 * With inline error
 *
 * ```jsx
 * <Strand errorMessage="Foobar">
 * </Strand>
 * ```
 *
 * ```jsx
 * <Strand>
 *   <div>Item 1</div>
 *   <div>Item 2</div>
 *   <div>Item 3</div>
 *   <div>Item 4</div>
 *   <div>Item 5</div>
 *   <div>Item 6</div>
 *   <div>Item 7</div>
 * </Strand>
 * ```
 *
 * ```jsx
 * <Strand full itemSize="large">
 *   <div>Item 1</div>
 *   <div>Item 2</div>
 *   <div>Item 3</div>
 *   <div>Item 4</div>
 *   <div>Item 5</div>
 *   <div>Item 6</div>
 *   <div>Item 7</div>
 * </Strand>
 * ```
 */

var Strand = /*#__PURE__*/function (_PureComponent) {
  _inherits(Strand, _PureComponent);

  var _super = _createSuper(Strand);

  function Strand(props) {
    var _this;

    _classCallCheck(this, Strand);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "state", {
      showPreviousControl: false,
      showNextControl: false
    });

    _defineProperty(_assertThisInitialized(_this), "_onSeeked", debounce(function () {
      var onSeeked = _this.props.onSeeked;

      if (typeof onSeeked === 'function') {
        return onSeeked.apply(void 0, arguments);
      }

      return undefined;
    }, ROUGH_SMOOTH_SCROLL_ANIMATION_DURATION_MS));

    _defineProperty(_assertThisInitialized(_this), "_handleScroll", debounce(function () {
      return _this._computeScrollProgress();
    }, ONE_FRAME_MS));

    _defineProperty(_assertThisInitialized(_this), "_previousPage", function () {
      var onPrevious = _this.props.onPrevious;
      var current = _this._node.current;
      if (!current) return;

      if (typeof onPrevious === 'function') {
        onPrevious();
      }

      var scrollLeft = _this._getScrollLeft();

      var pageWidth = _this._getSinglePageWidth();

      var scrollWidth = _this._getScrollWidth();

      var itemWidth = _this._getItemWidth();

      var gap = _this._getGutter();

      var totalItems = Math.round((scrollWidth + gap) / (itemWidth + gap));
      var itemsPerPage = Math.round(pageWidth / itemWidth);
      var remainder = totalItems % itemsPerPage;
      var flipFactor = isRtl() ? -1 : 1;
      var scrollAmount = _this._isOnLastPage() && remainder > 0 ? remainder * (itemWidth + gap) : pageWidth + gap;
      current.scrollTo({
        top: 0,
        left: (scrollLeft - scrollAmount) * flipFactor,
        behavior: 'smooth'
      });
    });

    _defineProperty(_assertThisInitialized(_this), "_nextPage", function () {
      var onNext = _this.props.onNext;
      var current = _this._node.current;
      if (!current) return;

      if (typeof onNext === 'function') {
        onNext();
      }

      var pageWidth = _this._getSinglePageWidth();

      var scrollLeft = _this._getScrollLeft();

      var gap = _this._getGutter();

      var flipFactor = isRtl() ? -1 : 1;
      var scrollAmount = pageWidth + gap;
      current.scrollTo({
        top: 0,
        left: (scrollLeft + scrollAmount) * flipFactor,
        behavior: 'smooth'
      });
    });

    _defineProperty(_assertThisInitialized(_this), "_computeScrollProgress", function () {
      var current = _this._node.current;
      if (!current) return;

      var scrollLeft = _this._getScrollLeft();

      var singlePageWidth = _this._getSinglePageWidth();

      var scrollWidth = _this._getScrollWidth();

      var pageCount = Math.ceil(scrollWidth / singlePageWidth);

      var isOnLastPage = _this._isOnLastPage();

      _this._onSeeked({
        progress: (scrollLeft + singlePageWidth) / scrollWidth,
        isLast: isOnLastPage,
        pageCount: pageCount
      });

      _this.setState({
        showPreviousControl: !_this._isOnFirstPage(),
        showNextControl: !isOnLastPage
      });
    });

    _defineProperty(_assertThisInitialized(_this), "_getCssDimension", function (element, rule) {
      if (!element) return 0;
      return parseInt(getComputedStyle(element)[rule] || 0, 10);
    });

    _defineProperty(_assertThisInitialized(_this), "_getDimension", function (element, dimension) {
      if (!element || typeof !element.getBoundingClientRect === 'function') return 0;
      return element.getBoundingClientRect()[dimension];
    });

    _this._node = /*#__PURE__*/createRef();
    _this._computeScrollProgress = _this._computeScrollProgress.bind(_assertThisInitialized(_this));
    _this._getCssDimension = _this._getCssDimension.bind(_assertThisInitialized(_this));
    _this._getDimension = _this._getDimension.bind(_assertThisInitialized(_this));
    _this._getFirstItem = _this._getFirstItem.bind(_assertThisInitialized(_this));
    _this._getGutter = _this._getGutter.bind(_assertThisInitialized(_this));
    _this._getItemWidth = _this._getItemWidth.bind(_assertThisInitialized(_this));
    _this._getItemWidthClasses = _this._getItemWidthClasses.bind(_assertThisInitialized(_this));
    _this._getScrollLeft = _this._getScrollLeft.bind(_assertThisInitialized(_this));
    _this._getScrollWidth = _this._getScrollWidth.bind(_assertThisInitialized(_this));
    _this._getSinglePageWidth = _this._getSinglePageWidth.bind(_assertThisInitialized(_this));
    _this._handleScroll = _this._handleScroll.bind(_assertThisInitialized(_this));
    _this._isOnFirstPage = _this._isOnFirstPage.bind(_assertThisInitialized(_this));
    _this._isOnLastPage = _this._isOnLastPage.bind(_assertThisInitialized(_this));
    _this._onSeeked = _this._onSeeked.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(Strand, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this._computeScrollProgress();

      window.addEventListener('resize', this._computeScrollProgress);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(_ref) {
      var wasLoading = _ref.loading;
      var isLoadingNow = this.props.loading;

      if (wasLoading !== isLoadingNow) {
        this._computeScrollProgress();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener('resize', this._computeScrollProgress);
    }
  }, {
    key: "_isOnFirstPage",
    value: function _isOnFirstPage() {
      var current = this._node.current;
      return current ? this._getScrollLeft() <= 0 : true;
    }
  }, {
    key: "_isOnLastPage",
    value: function _isOnLastPage() {
      var current = this._node.current;
      if (!current) return true;

      var singlePageWidth = this._getSinglePageWidth();

      var scrollWidth = this._getScrollWidth();

      var scrollLeft = this._getScrollLeft(); // The 10px threshold is to ensure we have a little wiggle room to account for
      // any rounding discrepancies


      return scrollLeft + singlePageWidth - scrollWidth > -10;
    }
  }, {
    key: "_getScrollLeft",
    value: function _getScrollLeft() {
      var current = this._node.current;
      if (!current) return 0;
      return current.scrollLeft * (isRtl() ? -1 : 1);
    }
  }, {
    key: "_getSinglePageWidth",
    value: function _getSinglePageWidth() {
      var current = this._node.current;
      if (!current) return 0;
      return this._getDimension(current.parentElement, 'width');
    }
  }, {
    key: "_getScrollWidth",
    value: function _getScrollWidth() {
      var current = this._node.current;
      if (!current) return 0;
      /**
       * We only get the left padding margin as they are defined symmetrically
       */

      var scrollPadding = this._getCssDimension(current, 'scrollPaddingLeft');

      var scrollMargin = this._getCssDimension(current.firstElementChild, 'scrollMarginLeft');

      return current.scrollWidth - (scrollMargin + scrollPadding) * 2;
    }
  }, {
    key: "_getFirstItem",
    value: function _getFirstItem() {
      var current = this._node.current;
      return safeSelect(current, 'firstElementChild');
    }
  }, {
    key: "_getGutter",
    value: function _getGutter() {
      return this._getCssDimension(this._getFirstItem(), isRtl() ? 'marginLeft' : 'marginRight');
    }
  }, {
    key: "_getItemWidth",
    value: function _getItemWidth() {
      return this._getDimension(this._getFirstItem(), 'width');
    }
  }, {
    key: "_getItemWidthClasses",
    value: function _getItemWidthClasses() {
      var itemSize = this.props.itemSize;

      if (itemSize === 'medium') {
        return classNames('psw-l-w-1/2', 'psw-l-w-1/3@tablet-s', 'psw-l-w-1/4@tablet-l', 'psw-l-w-1/6@laptop', 'psw-l-w-1/6@desktop', 'psw-l-w-1/6@max');
      }

      if (itemSize === 'small') {
        return classNames('psw-l-w-1/2', 'psw-l-w-1/4@tablet-s', 'psw-l-w-1/6@tablet-l', 'psw-l-w-1/6@laptop', 'psw-l-w-1/8@desktop', 'psw-l-w-1/8@max');
      }

      return classNames('psw-l-w-1/1', 'psw-l-w-1/2@tablet-s', 'psw-l-w-1/3@tablet-l', 'psw-l-w-1/3@laptop', 'psw-l-w-1/3@desktop', 'psw-l-w-1/3@max');
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          qa = _this$props.qa,
          children = _this$props.children,
          itemSize = _this$props.itemSize,
          full = _this$props.full,
          alignControls = _this$props.alignControls,
          previousControlLabel = _this$props.previousControlLabel,
          nextControlLabel = _this$props.nextControlLabel,
          loading = _this$props.loading,
          errorMessage = _this$props.errorMessage,
          loadingItem = _this$props.loadingItem;
      var _this$state = this.state,
          showPreviousControl = _this$state.showPreviousControl,
          showNextControl = _this$state.showNextControl;
      var childrenArray = Children.toArray(children);
      var isLoading = loading || errorMessage;

      if (isLoading) {
        return /*#__PURE__*/React.createElement(StrandStates, {
          qa: qa,
          full: full,
          itemWidth: this._getItemWidthClasses(),
          loading: loading,
          errorMessage: errorMessage,
          loadingItem: loadingItem
        });
      }

      if (!isLoading && childrenArray.length === 0) return null;
      return /*#__PURE__*/React.createElement("div", {
        "data-qa": qa,
        className: classNames('psw-strand', 'psw-l-anchor', 'psw-clip', "psw-with-".concat(itemSize, "-items"), full && 'psw-full')
      }, /*#__PURE__*/React.createElement("div", {
        className: classNames('psw-l-anchor', 'psw-l-z-0', 'psw-l-section')
      }, /*#__PURE__*/React.createElement("ul", {
        ref: this._node,
        onScroll: this._handleScroll,
        className: classNames('psw-strand-scroller', 'psw-l-line-left-top', 'psw-list-style-none', 'psw-l-space-x-5', 'psw-p-y-4', full ? 'psw-p-x-gm' : 'psw-p-x-4', full ? 'psw-m-sub-x-gm' : 'psw-m-sub-x-4', 'psw-hide-scrollbar')
      }, childrenArray.map(function (x, i) {
        return /*#__PURE__*/React.createElement("li", {
          "data-qa": "".concat(qa, "#item").concat(i),
          key: safeSelect(x, 'props.id') || i,
          className: classNames(_this2._getItemWidthClasses())
        }, x);
      }))), /*#__PURE__*/React.createElement("div", {
        className: classNames('psw-strand-controls', 'psw-l-anchor-top-center', 'psw-l-top-center', 'psw-pointer-events-off', 'psw-l-w-1/1', 'psw-l-line-center', 'psw-m-t-4', alignControls === 'center' && 'psw-fill-y')
      }, alignControls === '1:1-center' && /*#__PURE__*/React.createElement(MediaFrame, {
        className: classNames(this._getItemWidthClasses()),
        aspectRatio: "1:1"
      }), showPreviousControl && /*#__PURE__*/React.createElement("div", {
        className: "psw-l-anchor-center-left psw-pointer-events-on psw-l-inline"
      }, /*#__PURE__*/React.createElement(Button, {
        qa: "".concat(qa, "#previous"),
        ctaType: "primary",
        iconOnly: true,
        onClick: this._previousPage,
        ariaLabel: previousControlLabel
      }, /*#__PURE__*/React.createElement(Icon, {
        type: "chevron-left"
      }))), showNextControl && /*#__PURE__*/React.createElement("div", {
        className: "psw-l-anchor-center-right psw-pointer-events-on psw-l-inline"
      }, /*#__PURE__*/React.createElement(Button, {
        qa: "".concat(qa, "#next"),
        ctaType: "primary",
        iconOnly: true,
        onClick: this._nextPage,
        ariaLabel: nextControlLabel
      }, /*#__PURE__*/React.createElement(Icon, {
        type: "chevron-right"
      })))));
    }
  }]);

  return Strand;
}(PureComponent);

Strand.defaultProps = {
  qa: 'strand',
  children: null,
  itemSize: 'medium',
  full: false,
  alignControls: '1:1-center',
  previousControlLabel: '',
  nextControlLabel: '',
  loading: false,
  errorMessage: '',
  loadingItem: null,
  onSeeked: function onSeeked() {},
  onNext: function onNext() {},
  onPrevious: function onPrevious() {}
};
Strand.propTypes = {
  /**
   * Unique id used for qa automation. This should be unique to the page
   */
  qa: PropTypes.string,

  /**
   * The collection of items to render into the strand
   */
  children: PropTypes.arrayOf(PropTypes.node),

  /**
   * The relative size (based on width) of the items
   */
  itemSize: PropTypes.oneOf(['small', 'medium', 'large']),

  /**
   * Whether or not the strand should be full bleed (span the entire screen width)
   */
  full: PropTypes.bool,

  /**
   * How to align the controls (vertically)
   */
  alignControls: PropTypes.oneOf(['center', '1:1-center']),

  /**
   * Screen reader label for the previous control button
   */
  previousControlLabel: PropTypes.string,

  /**
   * Screen reader label for the next control button
   */
  nextControlLabel: PropTypes.string,

  /**
   * Whether the strand should be shown in a loading state
   */
  loading: PropTypes.bool,

  /**
   * The inline error message to display of the space maintained for the strand
   */
  errorMessage: PropTypes.node,

  /**
   * The loading UI to show per placeholder item in the strand
   */
  loadingItem: PropTypes.node,

  /**
   * Event callback, called when the content has been scrolled (roughly once per page
   * but not guarenteed)
   */
  onSeeked: PropTypes.func,

  /**
   * Event callback called when the next control is interacted with (will  not be called
   * for pure scrolling / swiping)
   */
  onNext: PropTypes.func,

  /**
   * Event callback called when the previous control is interacted with (will  not be called
   * for pure scrolling / swiping)
   */
  onPrevious: PropTypes.func
};
export default Strand;